/**
 * @generated SignedSource<<479781131f09f590dc8ca0b194c68b8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "password"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "password",
        "variableName": "password"
      },
      {
        "kind": "Variable",
        "name": "username",
        "variableName": "username"
      }
    ],
    "concreteType": "ObtainJSONWebToken",
    "kind": "LinkedField",
    "name": "tokenAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "authApiService_loginUserMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "authApiService_loginUserMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0a4886861a82b5ad84d5fe924626d01e",
    "id": null,
    "metadata": {},
    "name": "authApiService_loginUserMutation",
    "operationKind": "mutation",
    "text": "mutation authApiService_loginUserMutation(\n  $username: String!\n  $password: String!\n) {\n  tokenAuth(username: $username, password: $password) {\n    token\n  }\n}\n"
  }
};
})();

node.hash = "18cb099971f19c270b8647072c082a3c";

module.exports = node;
